import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { useMasterLookupsApi } from "../../../common/api/master-api/lookups/useMasterLookupsApi";
import { RejectionReasonReference } from "../../../common/types/RejectionReasonReference";
import { FileRecordRejectionReasonFormInputs } from "./FileRecordRejectionReasonFormInputs";

export const useFileRecordRejectionReasonForm = () => {
    const [rejectionReasons, setRejectionReasons] = useState<RejectionReasonReference[]>([]);

    const [areRejectionReasonsLoading, setAreRejectionReasonsLoading] = useState(false);

    const { control, errors, formState, reset, handleSubmit } = useForm<FileRecordRejectionReasonFormInputs>();

    const { getRejectionReasons } = useMasterLookupsApi();

    useEffect(() => {
        setAreRejectionReasonsLoading(true);
        getRejectionReasons()
            .then(({ items }) => setRejectionReasons(items))
            .finally(() => setAreRejectionReasonsLoading(false));
    }, []);

    return {
        control,
        errors,
        formState,
        handleSubmit,
        reset,
        rejectionReasons,
        areRejectionReasonsLoading
    };
};
